export const searchConstants = {
  FIELDS_REGEX: /(transform=)([^&\s\n\t\r]*)/i,
  ARRAY_REGEX: /([.]*)(\[\d\])[.]?(.*)/,
  DEFAULT_EXPIRY_DURATION_MILLISECONDS: 1200000, // 20 minutes
  ISPM_REGEX: /^ispm\//i,
  BULK_SEARCH_END_POINTS: 'bulkSearch',
  BUFFER_TIME_MILLISECONDS: 300,
  PARTIAL_INFORMATION: 'Partial information got loaded',
  PARTIAL_INFORMATION_FULL_MESSAGE: 'Only part of the data was loaded, click on the reload button to reload the page',
  RELOAD: 'Reload',
  ISPM_SERVER: 'ISPM',
  ISG_SERVER: 'ISG'
};
